import { useEffect, useState, useCallback } from "react";
import { getSiteImages, fileUrl } from "./api";

const P = "https://static.prod-images.emergentagent.com/jobs/83fd665c-12e1-46ec-b34b-7c468a7eac31/images";

// Default images shipped with the site. Admin uploads override these per key.
export const IMAGE_DEFAULTS = {
  landing_hero: `${P}/b2f6e5ab41253c81562fd816070a774e44fec66d2c9f35c709d8c5d3b4a40c46.jpeg`,
  landing_aerial: "https://images.unsplash.com/photo-1643067574858-250c69a0f152?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwyfHxhZXJpYWwlMjBjb2FzdGxpbmUlMjB0cm9waWNhbCUyMGlzbGFuZCUyMGJhaGFtYXN8ZW58MHx8fHwxNzg4ODcxODExfDA&ixlib=rb-4.1.0&q=85",
  services_hero: "https://images.unsplash.com/photo-1628158088791-89567a8e84ec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHw0fHxzdXJ2ZXlvciUyMHRvdGFsJTIwc3RhdGlvbiUyMGNvbnN0cnVjdGlvbiUyMHNpdGV8ZW58MHx8fHwxNzg4ODcxODExfDA&ixlib=rb-4.1.0&q=85",
  services_cta: "https://images.unsplash.com/photo-1643067574858-250c69a0f152?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwyfHxhZXJpYWwlMjBjb2FzdGxpbmUlMjB0cm9waWNhbCUyMGlzbGFuZCUyMGJhaGFtYXN8ZW58MHx8fHwxNzg4ODcxODExfDA&ixlib=rb-4.1.0&q=85",
  about_hero: `${P}/e7112c3fb1b86f7fc7ed5cb290f5734a0e6d3f95a3f95a2dac81c7e66b08b962.jpeg`,
  about_sharif: "",
  about_field_1: "https://images.unsplash.com/photo-1778041582108-2e765e738c8a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHw0fHxsYW5kJTIwc3VydmV5b3IlMjBjb25zdHJ1Y3Rpb24lMjBzaXRlJTIwdHJpcG9kfGVufDB8fHx8MTc4ODg4ODQ2Nnww&ixlib=rb-4.1.0&q=85",
  about_field_2: "https://images.unsplash.com/photo-1771068807150-2cab0734d25b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxsYW5kJTIwc3VydmV5b3IlMjBjb25zdHJ1Y3Rpb24lMjBzaXRlJTIwdHJpcG9kfGVufDB8fHx8MTc4ODg4ODQ2Nnww&ixlib=rb-4.1.0&q=85",
  about_field_3: "https://images.unsplash.com/photo-1682663810771-89d21838530f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxsYW5kJTIwc3VydmV5b3IlMjBjb25zdHJ1Y3Rpb24lMjBzaXRlJTIwdHJpcG9kfGVufDB8fHx8MTc4ODg4ODQ2Nnww&ixlib=rb-4.1.0&q=85",
  about_field_4: "https://images.unsplash.com/photo-1770822662903-aa69f6aa9b03?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxsYW5kJTIwc3VydmV5b3IlMjBjb25zdHJ1Y3Rpb24lMjBzaXRlJTIwdHJpcG9kfGVufDB8fHx8MTc4ODg4ODQ2Nnww&ixlib=rb-4.1.0&q=85",
  projects_hero: `${P}/b2f6e5ab41253c81562fd816070a774e44fec66d2c9f35c709d8c5d3b4a40c46.jpeg`,
  project_construction: `${P}/a00244f09ebff70f7f405370512e4403c7d6acaa5f4e8ada4ebab0f8b07cba2b.jpeg`,
  project_topographical: `${P}/2bd5605a7406295154a9f47172469dccc3d805f7c10f575da998656947128ca4.jpeg`,
  project_grading: `${P}/f5be2f13879f8cd7ad9cefa2e3f3ab6f2f0717c047d09a5bcc54471c8ad595fd.jpeg`,
  project_building: `${P}/85fb8a90bab606fa3baa9b6983953f42dcc90de60b316bdb0a7635236715aae0.jpeg`,
  project_volume: `${P}/b4daba07c8b6530befadc551e34e9f72f9f3e989c94117fd8a543e35839dc424.jpeg`,
  project_asbuilt: `${P}/766a38268be6ceb2af9a10a73ef9827f412d32a8a81e43496af4afe274091165.jpeg`,
  project_plan: `${P}/3525da964e3272cfd6bd2dd97071390b35edc6cda5c72315700f709a58a61c62.jpeg`,
  project_legal: `${P}/a8d7cdb2871f99038a7bd8b38921c8672f1d61b9403ca7521935c0849e4d285c.jpeg`,
  project_report: `${P}/91dcdf4980b08238d985040aa97462a1d116c8d8ce7d3274505c0626a6f51498.jpeg`,
  contact_hero: `${P}/e7112c3fb1b86f7fc7ed5cb290f5734a0e6d3f95a3f95a2dac81c7e66b08b962.jpeg`,
  request_sidebar: `${P}/b2f6e5ab41253c81562fd816070a774e44fec66d2c9f35c709d8c5d3b4a40c46.jpeg`,
};

// Grouped slot definitions for the admin "Photos" manager.
export const SITE_IMAGE_GROUPS = [
  { group: "Home Page", items: [
    { key: "landing_hero", label: "Hero background" },
    { key: "landing_aerial", label: "Aerial section" },
  ] },
  { group: "Services Page", items: [
    { key: "services_hero", label: "Hero background" },
    { key: "services_cta", label: "Call-to-action banner" },
  ] },
  { group: "About Page", items: [
    { key: "about_hero", label: "Hero background" },
    { key: "about_sharif", label: "Meet Sharif portrait" },
    { key: "about_field_1", label: "Field photo 1" },
    { key: "about_field_2", label: "Field photo 2" },
    { key: "about_field_3", label: "Field photo 3" },
    { key: "about_field_4", label: "Field photo 4" },
  ] },
  { group: "Projects Page", items: [
    { key: "projects_hero", label: "Hero background" },
    { key: "project_construction", label: "Construction Surveying" },
    { key: "project_topographical", label: "Topographical Survey" },
    { key: "project_grading", label: "Grading & Slope" },
    { key: "project_building", label: "Building Layout" },
    { key: "project_volume", label: "Volume Calculations" },
    { key: "project_asbuilt", label: "Project As-Built" },
    { key: "project_plan", label: "Plan Production" },
    { key: "project_legal", label: "Legal Descriptions" },
    { key: "project_report", label: "Surveying Report" },
  ] },
  { group: "Contact Page", items: [
    { key: "contact_hero", label: "Hero background" },
  ] },
  { group: "Request a Survey Page", items: [
    { key: "request_sidebar", label: "Sidebar image" },
  ] },
];

export const resolveImage = (overrides, key) => {
  const o = overrides?.[key];
  if (o?.storage_path) return fileUrl(o.storage_path);
  return IMAGE_DEFAULTS[key] || "";
};

export const useSiteImages = () => {
  const [overrides, setOverrides] = useState({});
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const data = await getSiteImages();
      setOverrides(data || {});
    } catch {
      setOverrides({});
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const img = useCallback((key) => resolveImage(overrides, key), [overrides]);
  return { img, overrides, loading, refresh };
};
